var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "volumeBox"
  }, [_c('canvas', {
    class: _vm.rtilCode + 'Left'
  }), _c('canvas', {
    class: _vm.rtilCode + 'Right'
  }), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', [_vm._v("+4")]), _c('div', [_vm._v("0")]), _c('div', [_vm._v("-6")]), _c('div', [_vm._v("-12")]), _c('div', [_vm._v("-18")]), _c('div', [_vm._v("-36")])]);
}];
export { render, staticRenderFns };